import { render, staticRenderFns } from "./AppButtonLegacy.vue?vue&type=template&id=2273114e&scoped=true"
import script from "./AppButtonLegacy.vue?vue&type=script&lang=js"
export * from "./AppButtonLegacy.vue?vue&type=script&lang=js"
import style0 from "./AppButtonLegacy.vue?vue&type=style&index=0&id=2273114e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2273114e",
  null
  
)

export default component.exports